import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';
import {ExcelService} from '../../excel.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};


@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css'],
      providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
        {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
      ] 
})
export class BaseComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  fecIni:any = moment();
  fecFin:any = moment();
  totales:any=[];
  titulo:string="MACSI";

  constructor(private dataService: DataService, private excelService: ExcelService) { }

  ngOnInit() {
    this.dataService.getPres_Totales(20250101, 20250531).subscribe(
      rows => {   
              this.totales = <any>rows
              },          
      error => this.errMsg = <any>error,
      () => this.fnTotalesCargados());
  }

  fnTotalesCargados(){
    console.log(this.totales);
  }

}
